import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Product, ProductRequest } from "../../../../service/model/store.model";
import { Box, Button, Dialog, DialogTitle, Grid } from "@mui/material";
import FormField from "../../../../components/form-controls/form-field";
import theme from "../../../../app/app-theme";
import { DEFAULT_LOW_STOCK_THRESHOLD } from "../../../../shared/constants";
import FormCloseButton from "../../../../components/form-controls/form-close-button";
import { FormTextField } from "../../../../components/form-input-field-wrappers/form-controller-inputs/form-text-field";

interface ProductFormProps {
    readonly product?: Product
    readonly editable: boolean
    readonly onClose: () => void
    readonly onSubmit: (data: ProductRequest) => void
}

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 400,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

const ProductForm: React.FC<ProductFormProps> = ({ product, onClose, onSubmit }) => {
    const schema = yup.object().shape({
        name: yup.string()
            .required(),
        description: yup.string(),
        lowStockThreshold: yup.number()
            .required()
            .min(0, 'Low stock threshold cannot be negative')
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmitHandler = (data: any) => {
        onSubmit(data as ProductRequest)
    };

    return (
        <Dialog open={true} onClose={onClose} sx={style}>
            <DialogTitle>Product Details</DialogTitle>
            <Box sx={style}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <form onSubmit={handleSubmit(onSubmitHandler)}>
                        <FormField>
                            <FormTextField
                                id="product-name"
                                label="Product Name"
                                name="name"
                                variant="outlined"
                                defaultValue={product?.name}
                                errorMessage={errors.name?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="product-description"
                                label="Description"
                                name="description"
                                variant="outlined"
                                defaultValue={product?.description}
                                errorMessage={errors.description?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormTextField
                                id="low-stock-threshold"
                                type="number"
                                name="lowStockThreshold"
                                label="Low Stock Threshold"
                                variant="outlined"
                                defaultValue={product?.lowStockThreshold ?? DEFAULT_LOW_STOCK_THRESHOLD}
                                errorMessage={errors.lowStockThreshold?.message}
                                register={register}
                            />
                        </FormField>
                        <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                            <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                            <Button type="submit" variant="contained" >Submit</Button>
                        </Grid>
                    </form>
                </>
            </Box>
        </Dialog>
    );
}

export default ProductForm;